export default __webpack_public_path__ + "static/media/comp2.ec17b041.png";